import { Navigate, Route, Routes } from 'react-router-dom';
import { QuizSelector, RootQuizSelector } from 'pages';
import { PrivateRoute, SnackbarProvider } from 'components';
import { GlobalContextProvider, UserProvider, useAuth } from 'contexts';

import 'styles/global.css';
import 'styles/App.css';

import { EventSetup } from 'pages/event/event-setup';
import { QuizSetup } from 'pages/quiz-setup';
import { UserProfile } from 'pages/user-profile';
import { CreateQuiz } from 'pages/quiz-settings';
import { QuizSessionQuizSelector } from 'pages/quiz-session';

interface Props {
    eventAlias?: string;
    isEventSignup?: boolean;
}

export const AppSetup = (props: Props) => {
    const auth = useAuth();
    return (
        <SnackbarProvider>
            <UserProvider authCurrentUser={auth.currentUser}>
                <GlobalContextProvider eventAlias={props.eventAlias}>
                    <Routes>
                        {/* private paths */}
                        <Route path="/" element={<PrivateRoute eventAlias={props.eventAlias} />}>
                            <Route path="/quiz/:quizId/*" element={<QuizSetup />} />
                            <Route path="/profile" element={<UserProfile />} />
                            <Route path="/quiz-selector" element={<QuizSelector />} />
                            <Route path="/root-quiz-selector" element={<RootQuizSelector />} />
                            <Route path="/session/create" element={<QuizSessionQuizSelector />} />
                            <Route path="/quiz/create" element={<CreateQuiz />} />
                            <Route path="/:eventAlias/*" element={<EventSetup />} />
                            <Route path="/" element={<QuizSelector />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Route>
                    </Routes>
                </GlobalContextProvider>
            </UserProvider>
        </SnackbarProvider>
    );
}
